import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
  AuthActionTypes,
  ActionAuthLoginSubmit,
  ActionAuthLoginSubmitSuccess,
  ActionAuthLoginSubmitError,
  ActionAuthLogoutSubmit,
  ActionAuthLogoutSubmitSuccess,
  ActionAuthLogoutSubmitError,
  ActionAuthForgotPasswordSubmit,
  ActionAuthForgotPasswordSubmitSuccess,
  ActionAuthForgotPasswordSubmitError,
  ActionAuthVerifyOTPSubmit,
  ActionAuthVerifyOTPSubmitSuccess,
  ActionAuthVerifyOTPSubmitError,
  ActionAuthChangePasswordSubmitError,
  ActionAuthChangePasswordSubmit,
  ActionAuthChangePasswordSubmitSuccess,
  ActionAuthSignupInit,
  ActionAuthSignupSubmit,
  ActionAuthSignupSubmitSuccess,
  ActionAuthSignupSubmitError,
  ActionAuthSendOTPSubmit,
  ActionAuthSendOTPSubmitSuccess,
  ActionAuthSendOTPSubmitError,
} from './types';
import AuthService from './effects';
import { parseJWT } from '../../helpers/util';
import { LoginFormPayload, LoginResponse, SendOTPFormPayload, VerifyOTPFormPayload, VerifiedOTPResponse, ChangePasswordFormPayload, SignupFormPayload, SignupResponse, StoreUser } from '../../models/authentication';
import { actionCreateUser } from '../user/action';
import { APIError, ErrorResponse } from '../../helpers/types';
import { defaultLang } from '../../hoc/i18n/i18n';
import i18next from 'i18next';

// SIGNUP
export const dispatchAuthSignupInit = (): ActionAuthSignupInit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SIGNUP_INIT,
  };
};
export const dispatchAuthSignupSubmit = (): ActionAuthSignupSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT,
  };
};
export const dispatchAuthSignupSubmitSuccess = (): ActionAuthSignupSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_SUCCESS,
  };
};
export const dispatchAuthSignupSubmitError = (e: APIError): ActionAuthSignupSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SIGNUP_SUBMIT_ERROR,
    error: e,
  };
};

// LOGIN
export const dispatchAuthLoginSubmit = (): ActionAuthLoginSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT,
  };
};
export const dispatchAuthLoginSubmitSuccess = (payload: LoginResponse): ActionAuthLoginSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_SUCCESS,
    payload,
  };
};
export const dispatchAuthLoginSubmitError = (e: APIError): ActionAuthLoginSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGIN_SUBMIT_ERROR,
    error: e,
  };
};

// LOGOUT
export const dispatchAuthLogoutSubmit = (): ActionAuthLogoutSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT,
  };
};
export const dispatchAuthLogoutSubmitSuccess = (): ActionAuthLogoutSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_SUCCESS,
  };
};
export const dispatchAuthLogoutSubmitError = (e: APIError): ActionAuthLogoutSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_LOGOUT_SUBMIT_ERROR,
    error: e,
  };
};

// FORGOT PASSWORD
export const dispatchAuthForgotPasswordSubmit = (): ActionAuthForgotPasswordSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT,
  };
};
export const dispatchAuthForgotPasswordSubmitSuccess = (): ActionAuthForgotPasswordSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_SUCCESS,
  };
};
export const dispatchAuthForgotPasswordSubmitError = (e: APIError): ActionAuthForgotPasswordSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_FORGOTPASSWORD_SUBMIT_ERROR,
    error: e,
  };
};

// SEND OTP
export const dispatchAuthSendOTPSubmit = (payload: SendOTPFormPayload): ActionAuthSendOTPSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT,
    payload,
  };
};
export const dispatchAuthSendOTPSubmitSuccess = (): ActionAuthSendOTPSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_SUCCESS,
  };
};
export const dispatchAuthSendOTPSubmitError = (e: APIError): ActionAuthSendOTPSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_SENDOTP_SUBMIT_ERROR,
    error: e,
  };
};

// VERIFY OTP
export const dispatchAuthVerifyOTPSubmit = (): ActionAuthVerifyOTPSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT,
  };
};
export const dispatchAuthVerifyOTPSubmitSuccess = (payload: VerifiedOTPResponse): ActionAuthVerifyOTPSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_SUCCESS,
    payload,
  };
};
export const dispatchAuthVerifyOTPSubmitError = (e: APIError): ActionAuthVerifyOTPSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_VERIFYOTP_SUBMIT_ERROR,
    error: e,
  };
};

// CHANGE PASSWORD
export const dispatchAuthChangePasswordSubmit = (payload: ChangePasswordFormPayload): ActionAuthChangePasswordSubmit => {
  return {
    type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT,
    payload,
  };
};
export const dispatchAuthChangePasswordSubmitSuccess = (): ActionAuthChangePasswordSubmitSuccess => {
  return {
    type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_SUCCESS,
  };
};
export const dispatchAuthChangePasswordSubmitError = (e: APIError): ActionAuthChangePasswordSubmitError => {
  return {
    type: AuthActionTypes.ACTION_AUTH_CHANGEPASSWORD_SUBMIT_ERROR,
    error: e,
  };
};

const storeUser = (token: string, decodedJWT: any, email: string): StoreUser => {
  const expiryDate = new Date(decodedJWT.exp * 1000);
  localStorage.setItem('token', token);
  localStorage.setItem('expirationDate', String(expiryDate));
  localStorage.setItem('email', email);
  localStorage.setItem('roles', decodedJWT.roles);
  localStorage.setItem('userId', decodedJWT.uid);
  localStorage.setItem('partner', decodedJWT.ccs[0].partner);
  localStorage.setItem('customerId', decodedJWT.ccs[0].teamId);
  localStorage.removeItem('i18nextLng');
  return { token: token, userId: decodedJWT.uid, email: email, expiryDate: expiryDate };
};

export const checkAuthTimeout = (expiry: number) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    expiry = (expiry >= 2147483647) ? 2147483647 : expiry; // maximum delay supported by settimeout function is 2147483647 ms
    setTimeout(() => {
      dispatch(actionLogout());
    }, expiry);
  };
};

export const actionSignUp = (payload: SignupFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthSignupSubmit());
    return AuthService.signup(payload).then(async (result: SignupResponse) => {
      const user = storeUser(result.emailIdentity, parseJWT(result.emailIdentity), '');
      await getUserState(dispatch, user);
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchAuthSignupSubmitError(e.response));
    });
  };
};

export const actionLogin = (payload: LoginFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthLoginSubmit());
    return AuthService.login(payload).then(async (result: LoginResponse) => {
      const lang = defaultLang();
      if (lang) {
        i18next.changeLanguage(lang);
      }
      const user = storeUser(result.token, parseJWT(result.token), payload.username);
      dispatch(dispatchAuthLoginSubmitSuccess(result));
      await getUserState(dispatch, user);
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchAuthLoginSubmitError(e.response));
    });
  };
};

export const actionLogout = () => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthLogoutSubmit());
    const i18nextLng = localStorage.getItem('i18nextLng');
    localStorage.clear();
    if (i18nextLng)
      localStorage.setItem('i18nextLng', i18nextLng);
    dispatch(dispatchAuthLogoutSubmitSuccess());
  };
};

export const getUserState = async (dispatch: ThunkDispatch<any, any, AnyAction>, user: StoreUser) => {
  dispatch(dispatchAuthLoginSubmitSuccess({ token: user.token }));
  dispatch(actionCreateUser({ userId: user.userId, email: user.email }));
  dispatch(checkAuthTimeout((user.expiryDate.getTime() - new Date().getTime())));
  return;
};

export const checkAuthState = () => {
  return async (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    if (token && userId && email) {
      const expirationDate = new Date(String(localStorage.getItem('expirationDate')));
      if (expirationDate <= new Date()) {
        dispatch(actionLogout());
      } else {
        await getUserState(dispatch, { token: token, userId: userId, email: email, expiryDate: expirationDate });
      }
    }
  };
};

export const actionSendOTP = (payload: SendOTPFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthSendOTPSubmit(payload));
    return AuthService.sendOTP(payload).then(() => {
      return dispatch(dispatchAuthSendOTPSubmitSuccess());
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchAuthSendOTPSubmitError(e.response));
    });
  };
};

export const actionVerifyOTP = (payload: VerifyOTPFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthVerifyOTPSubmit());
    return AuthService.verifyOTP(payload).then((result) => {
      return dispatch(dispatchAuthVerifyOTPSubmitSuccess(result));
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchAuthVerifyOTPSubmitError(e.response));
    });
  };
};

export const actionChangePassword = (payload: ChangePasswordFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchAuthChangePasswordSubmit(payload));
    return AuthService.changePassword(payload).then(() => {
      return dispatch(dispatchAuthChangePasswordSubmitSuccess());
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchAuthChangePasswordSubmitError(e.response));
    });
  };
};